// // Helper function for escaping HTML characters
export function escapeHTML(str: string): string {
    return str
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');
}

// // Helper function for escaping JavaScript characters
// export function escapeJavaScript(str: string): string {
//     return str
//         .replaceAll('\\', '\\\\')
//         .replaceAll("'", "\\'")
//         .replaceAll('"', '\\"')
//         .replaceAll('/', '\\/')
//         .replaceAll('<', '\\x3C')
//         .replaceAll('>', '\\x3E')
//         .replaceAll('`', '\\`')
//         .replaceAll('\n', '\\n')
//         .replaceAll('\r', '\\r');
// }

// // Main sanitise function
// export function sanitise(input: string): string {
//     try {
//         if (typeof input === "number") {
//             input = (input as Number).toString();
//         }

//         if (Array.isArray(input)) {
//             input = (input as any[]).join(', ');
//         }

//         const escapedHTML = escapeHTML(input as any instanceof Number ? input.toString() : input);
//         return escapeJavaScript(escapedHTML);
//     } catch (error) {
//         console.error('Error sanitising input:', error, input);
//     }
// }

// Main sanitise function
export function sanitise(input: string): string {
    console.log("Sanitising input:", input);
    try {
        if (typeof input === "number") {
            input = (input as number).toString();
        }

        if (Array.isArray(input)) {
            input = input.join(', ');
        }

        return escapeHTML(input);
    } catch (error) {
        console.error('Error sanitising input:', error, input);
        return ''; // Return empty string or original input as needed
    }
}